import { observable } from "mobx";
import { Type } from "class-transformer";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RegisteredChargeResponse {
  /**
   * Price list item ID.
   */
  @observable
  priceListItemId!: string;

  /**
   * Beginning date of charge validity.
   */
  @observable
  @Type(() => Date)
  validSince!: Date;

  /**
   * End date of charge validity.
   */
  @observable
  @Type(() => Date)
  validUntil!: Date;

  /**
   * Charge is currently valid
   */
  @observable
  isCurrentlyValid!: boolean;
}
